import { OrganizationConfig } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/organization-config/model';
import { updateExoOrganizationConfig } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/organization-config/actions';

export function Remediate(_tenant: string, data: Partial<OrganizationConfig>, schema: any) {
    if (schema.properties.RejectDirectSend.const === false) {
        return updateExoOrganizationConfig({ _tenant, data: { RejectDirectSend: false } });
    }

    if (schema.properties.RejectDirectSend.const === true) {
        return updateExoOrganizationConfig({ _tenant, data: { RejectDirectSend: true } });
    }
}
